function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3696",
  "data-name": "Path 3696",
  d: "M5809.609,1452.064a12.369,12.369,0,0,0-6.828,1.859,8.9,8.9,0,0,0-3.261,3.547,7.109,7.109,0,0,0-.747,3.712,7.4,7.4,0,0,0,1.6,4.094,10.139,10.139,0,0,0,4.649,3.3,12.4,12.4,0,0,0,4.956.726c.475-.024.948-.088,1.418-.154a2.031,2.031,0,0,1,1.31.23,9.737,9.737,0,0,0,2.734,1.029,3.169,3.169,0,0,0,.98.087h.011c.11-.018.232-.024.28-.144s-.043-.2-.109-.282c-.189-.241-.4-.466-.569-.723a1.669,1.669,0,0,1,.432-2.3,9.223,9.223,0,0,0,1.988-2.017,7.426,7.426,0,0,0,1.367-3.39,7.14,7.14,0,0,0-.867-4.482,9.175,9.175,0,0,0-3.5-3.481,11.453,11.453,0,0,0-4.324-1.469C5810.526,1452.123,5809.919,1452.092,5809.609,1452.064Z",
  transform: "translate(-5797.756 -1451.063)",
  fill: "none",
  stroke: "#2a343f",
  strokeWidth: 2
});

var SvgChatInactiveIcon = function SvgChatInactiveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.128,
    height: 20.435,
    viewBox: "0 0 23.128 20.435",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatInactiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-inactive-icon.92b11187.svg";
export { ForwardRef as ReactComponent };